module.exports = __webpack_public_path__ + "fonts/Inter-900-vietnamese64.74fe938.woff2";